import axios from 'axios'
import { SHIPPER_PORTAL_PREFIX } from 'constants/app.constants'
import { useMutation } from 'react-query'
import { getCTSDK } from 'services/ctClient'
import { User, UserRole } from 'types/user.types'

const sdk = getCTSDK()

export const useLoginOld = () => {
    return useMutation((params: { email: string; password: string }) =>
        sdk.post<{ token: string; refreshToken: string }>('/loginOld', params)
    )
}

export const useAuthLogin = () => {
    return useMutation(
        (params: { orgId: string | null; accessToken: string }) =>
            axios.post<{ user: User; token: string; refreshToken: string }>(
                `${process.env.REACT_APP_API_URL_V3}/authLogin`,
                { orgId: params.orgId },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${params.accessToken}`,
                    },
                }
            )
    )
}

export const useLogin = () => {
    return useMutation((params: { email: string }) =>
        sdk.post<{ token: string; refreshToken: string }>('/login', params)
    )
}

export const useMagicLinkLogin = () => {
    return useMutation((params: { email: string; loginToken: string }) =>
        sdk.post<{ token: string; refreshToken: string }>(
            '/magicLinkLogin',
            params
        )
    )
}

export const useRegister = () => {
    return useMutation(
        ({
            email,
            orgId,
            password,
            firstName,
            lastName,
        }: {
            email: string
            orgId: string
            password: string
            firstName: string
            lastName: string
        }) =>
            sdk.post<{ token: string }>('/register', {
                email,
                orgId,
                password,
                firstName,
                lastName,
            })
    )
}

type Model = User
const BASE_URL = '/users'
const ELEMENT_NAME = 'user'

const getUniversalBaseURL = (role?: UserRole) => {
    return `${role === 'customerUser' ? SHIPPER_PORTAL_PREFIX : ''}${BASE_URL}`
}

export const useUniversalCreateUser = (role: UserRole) => {
    return useMutation((data: Partial<Model>) =>
        sdk
            .post<{ [ELEMENT_NAME]: Model }>(getUniversalBaseURL(role), {
                data,
            })
            .then((res) => res.data[ELEMENT_NAME])
    )
}

export const useUniversalUpdateUser = (role: UserRole) => {
    return useMutation((data: { id: string; [ELEMENT_NAME]: Partial<Model> }) =>
        sdk
            .put<{ [ELEMENT_NAME]: Model }>(
                `${getUniversalBaseURL(role)}/${data.id}`,
                {
                    [ELEMENT_NAME]: data[ELEMENT_NAME],
                }
            )
            .then((res) => res.data[ELEMENT_NAME])
    )
}

export const useUniversalDeleteUsers = (role: UserRole) => {
    return useMutation((ids: string[]) =>
        sdk.delete(getUniversalBaseURL(role), {
            data: { ids },
        })
    )
}
